var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAlertGeneral = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 25,
  height: 25,
  viewBox: "0 0 25 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.5023 5.09863C8.415 5.09863 5.10156 8.41208 5.10156 12.4994C5.10156 16.5868 8.415 19.9002 12.5023 19.9002C16.5897 19.9002 19.9031 16.5868 19.9031 12.4994C19.9031 8.41208 16.5897 5.09863 12.5023 5.09863ZM3.10156 12.4994C3.10156 7.30751 7.31044 3.09863 12.5023 3.09863C17.6943 3.09863 21.9031 7.30751 21.9031 12.4994C21.9031 17.6913 17.6943 21.9002 12.5023 21.9002C7.31044 21.9002 3.10156 17.6913 3.10156 12.4994Z",
  fill: "#15A779"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.5 15.8604C11.5 15.3081 11.9477 14.8604 12.5 14.8604H12.5084C13.0607 14.8604 13.5084 15.3081 13.5084 15.8604C13.5084 16.4126 13.0607 16.8604 12.5084 16.8604H12.5C11.9477 16.8604 11.5 16.4126 11.5 15.8604Z",
  fill: "#15A779"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.5 8.13867C13.0523 8.13867 13.5 8.58639 13.5 9.13867V12.499C13.5 13.0513 13.0523 13.499 12.5 13.499C11.9477 13.499 11.5 13.0513 11.5 12.499V9.13867C11.5 8.58639 11.9477 8.13867 12.5 8.13867Z",
  fill: "#15A779"
})));
export default SvgAlertGeneral;